import { render, staticRenderFns } from "./WithdrawRequests.vue?vue&type=template&id=4a132fa0&scoped=true"
import script from "./WithdrawRequests.vue?vue&type=script&lang=js"
export * from "./WithdrawRequests.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRequests.vue?vue&type=style&index=0&id=4a132fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a132fa0",
  null
  
)

export default component.exports